import { useContext } from "react";
import BaseActions, { APIRequestGenerator } from "base/BaseActions";
import BaseModel from "base/BaseModel";
import APIHelper from "base/APIHelper";
import UserModel from "./userModel";

const module = "PointTransaction";

const usePointTransactionModel = () => {
  const { token } = useContext(UserModel.Context);

  const { getList, getOne, getSchema, createOne, updateOne, deleteOne } =
    BaseActions(module, { token });

  async function voidOne(body) {
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/voiding`,
      null,
      token,
    );
    try {
      const response = await APIHelper(
        "POST",
        url.toString(),
        body,
        true,
        headers,
      );

      const { records } = response || {};
      const [record = {}] = records || [];

      return Promise.resolve(record);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getList,
    getOne,
    getSchema,
    createOne,
    updateOne,
    deleteOne,
    voidOne,
  };
};

const PointTransactionModel = BaseModel(
  usePointTransactionModel,
  "PointTransactionModel",
);

export { usePointTransactionModel };
export default PointTransactionModel;
